<template>
  <div class="page">
    <el-container>
      <el-header>
        <Aside />
      </el-header>
      <el-main>
        <router-view></router-view>
      </el-main>
      <el-footer>
        <i-footer></i-footer>
      </el-footer>
    </el-container>
  </div>
</template>

<script>
import Aside from '@/components/aside'
import iFooter from '@/components/footer'
export default {
  name: 'App',
  components: {
    Aside,
    iFooter
  },
  data() {
    return {
      
    }
  },
  created() {
  }
}
</script>

<style lang="stylus" scope>
.el-container
  min-height 100vh
.el-container,.el-header
  width 100%
  min-width 1240px
  .el-header
    background #2c2c2c
  .el-main
    min-width 1200px
    margin 0 auto
    padding 0px
</style>
<style>

textarea{
  font-family: 'Microsoft Yahei', Menlo, Monaco, Consolas, Courier New, monospace !important;
}
</style>
